module.exports = __webpack_public_path__ + "img/logo.c0738f99.jpg";